<template>
  <transition name="default-opacity-transition" mode="out-in">
    <s-loader v-if="loading"/>
    <router-view
      v-else
      :asset="currentAsset"
      :asset-type="currentAssetType"
      :sensor="sensor"
    />
  </transition>
</template>
<script>
import ModuleMenuService from '@/domain/services/installation/modules/menu';
import loadingMixin from '@/services/loadingMixin';
import eventBus from '@/services/globalEventBus';
import AssetAccessorMixin from '@/domain/mixins/installation/assetAccessorMixin';
import AssetTreeviewInstallationAcessMixin from '@/components/treeview/assetTreeviewInstallationAcessMixin';
import menuEvents from '@/domain/events/menu';
import { mapGetters } from 'vuex';

export default {
  name: 'Supervision',
  mixins: [
    loadingMixin,
    AssetAccessorMixin,
    AssetTreeviewInstallationAcessMixin,
  ],
  data: () => ({
    sensorsList: [],
    sensor: null,
  }),
  created() {
    this.initListener();
    this.handleMenuItems(this.assetSubMenu.items);
  },
  computed: {
    ...mapGetters([
      'assetSubMenu',
    ]),
  },
  beforeDestroy() {
    this.removeListener();
  },
  beforeRouteUpdate(to, from, next) {
    this.startLoading();
    next();
    this.sensor = ModuleMenuService.verifySensorRoute(to, this.sensorsList);
    this.endLoading();
  },
  methods: {
    initListener() {
      eventBus.on(menuEvents.refreshMenuItems, this.handleMenuItems, this);
    },
    removeListener() {
      eventBus.off(menuEvents.refreshMenuItems, this.handleMenuItems, this);
    },
    async handleMenuItems(menuItems) {
      if (!menuItems) {
        return;
      }
      this.startLoading();
      ModuleMenuService.checkSupervisionItems(menuItems);
      this.sensorsList = menuItems;
      this.sensor = await ModuleMenuService.verifySensorRoute(this.$route, this.sensorsList);
      this.$route.meta.currentRouteModuleSubtype = this.sensor?.subtype || '';
      this.endLoading();
    },
  },
};
</script>
